import { createContext } from 'react';

import { defaultThreshold } from '../constants.js';
import { TimeseriesChartThresholdsConfig } from '../types/timeseries-config.js';

export const TimeseriesThresholdContext =
  createContext<TimeseriesChartThresholdsConfig>(defaultThreshold);

TimeseriesThresholdContext['displayName'] = 'TimeseriesThresholdContext';
